import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import PaymentTable from '../../../../../components/PaymentTable';
import Card from '../../../../../components/Card';

const propTypes = {
  user: PropTypes.object,
};

const Payments = ({ user }) => (
  <Fragment>
    <Card>
      <Card.Header>Payment History</Card.Header>
      <Card.Body>
        Below is a history of all of {user.firstName} {user.lastName}'s payments.
      </Card.Body>
    </Card>
    <PaymentTable admin transactions={user.payments} />
  </Fragment>
);

Payments.propTypes = propTypes;

export default Payments;
